import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type YesNoSelectProps = Omit<
  TextFieldProps,
  'select' | 'children' | 'value' | 'onChange'
> & {
  value?: boolean
  onChange?: (value: boolean) => void
}

export default function YesNoSelect({ value, onChange, ...props }: YesNoSelectProps) {
  const { t } = useTranslation('actions')

  return (
    <TextField
      select
      value={value === undefined ? '' : String(value)}
      onChange={(event) => onChange?.(event.target.value === 'true')}
      {...props}
    >
      <MenuItem value="true">{t('yes')}</MenuItem>
      <MenuItem value="false">{t('nope')}</MenuItem>
    </TextField>
  )
}
